<template>
	<div class="imageUpload">
		<DropZone
			class="drop-area"
			@files-dropped="addFiles"
			#default="{ dropZoneActive }"
		>
			<label for="file-input">
				<span v-if="dropZoneActive">
					<span>Drop Them Here</span>
					<span class="smaller">to add them</span>
				</span>
				<span v-else>
					<span>Drag Your Files Here</span>
					<span class="smaller">
						or <strong><em>click here</em></strong> to select files
					</span>
				</span>

				<input type="file" id="file-input" multiple @change="onInputChange" />
			</label>
			<ul class="image-list" v-show="files.length">
				<FilePreview
					v-for="file of files"
					:key="file.id"
					:file="file"
					tag="li"
					@remove="removeFile"
				/>
			</ul>
		</DropZone>
		<button @click.prevent="uploadImages(files)" class="upload-button">
			Upload Image/s
		</button>
	</div>
</template>

<script>
	// Components
	import DropZone from "./ImageDropZone.vue";
	import FilePreview from "./ImageFilePreview.vue";
	// Uploader
	import createUploader from "@/helpers/imageUploader";
	// File Management
	import useFileList from "@/helpers/imageFileList";
	export default {
		name: "BaseImageUpload",

		components: {
			DropZone,
			FilePreview,
		},
		props: {
			urlParam: { type: String },	
		},
		emits: ["images-data"],

		setup: (props, { emit }) => {
			const { files, addFiles, removeFile } = useFileList();
			function onInputChange(e) {
				addFiles(e.target.files);
				e.target.value = null; // reset so that selecting the same file again will still cause it to fire this change
			}
			// Uploader
			const { uploadFiles } = createUploader(
				`${process.env.VUE_APP_API_URL}files?path=${props.urlParam}`,
			);

			const uploadImages = async (files) => {
				let response = await uploadFiles(files);
				let images = response.map(
					(responseObj) => responseObj.data.data[0].url,
				);
				emit("images-data", images);
			};

			return {
				onInputChange,
				addFiles,
				files,
				removeFile,
				uploadFiles,
				uploadImages,
			};
		},
	};
</script>

<style scoped>
	.imageUpload {
		font-family: Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.drop-area {
		width: 100%;
		margin: 0 auto;
		margin-top: 1rem;
		padding: 50px;
		background: #ffffff55;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
		transition: 0.2s ease;
	}
	.drop-area[data-active="true"] {
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
		background: #ffffffcc;
	}
	label {
		font-size: 30px;
		cursor: pointer;
		display: block;
	}
	input[type="file"]:not(:focus-visible) {
		position: absolute !important;
		width: 1px !important;
		height: 1px !important;
		padding: 0 !important;
		margin: -1px !important;
		overflow: hidden !important;
		clip: rect(0, 0, 0, 0) !important;
		white-space: nowrap !important;
		border: 0 !important;
	}

	.smaller {
		font-size: 14px;
	}
	span {
		display: block;
	}
	.image-list {
		display: flex;
		list-style: none;
		flex-wrap: wrap;
		padding: 0;
	}
	.upload-button {
		display: block;
		max-width: 100%;
		appearance: none;
		border: 0;
		border-radius: 10px;
		padding: 0.6rem 3rem;
		margin: 0.6rem 0 2rem 0;
		font-size: 0.8rem;
		background: #4a4c52;
		color: #fff;
	}
	button {
		cursor: pointer;
	}
</style>
